import React from 'react';
import styles from './StudentCourseTotalRow.module.css';
import MLIcon from '../../../components/MLIcon';
import StudentDetailsCell from '../../../components/StudentDetailsCell/StudentDetailsCell';
import clsx from 'clsx';
import { LOW_SCORE_THRESHOLD } from '../../constants';
import {
  toRoundedPercent,
  formatGrade,
  formatChange,
} from '../../utils/studentCourseTotalUtils';

const StudentCourseTotalRow = ({ student, handleISGLaunch, setOpen }) => {
  const isCurrentLowScoring =
    student.currentGrade != null && student.currentGrade <= LOW_SCORE_THRESHOLD;

  const roundedCurrent = toRoundedPercent(student.currentGrade);
  const roundedPrevious = toRoundedPercent(student.previousGrade);
  const hasChange = roundedCurrent != null && roundedPrevious != null;

  return (
    <tr className={styles.studentRow}>
      <StudentDetailsCell
        studentId={student.user_id}
        firstName={student.firstName}
        lastName={student.lastName}
        email={student.email}
        showWarning={isCurrentLowScoring}
        handleISGLaunch={handleISGLaunch}
        setOpen={setOpen}
        nameTestId="course_total_open_isg_from_student_name"
      />
      <td className={styles.studentGrade} tabIndex={0}>
        {formatGrade(student.currentGrade)}
      </td>
      <td className={styles.studentGrade} tabIndex={0}>
        {formatGrade(student.previousGrade)}
      </td>
      <td
        className={clsx(styles.studentGrade, styles.changeCell, {
          [styles.positiveChange]:
            hasChange && roundedCurrent > roundedPrevious,
          [styles.negativeChange]:
            hasChange && roundedCurrent < roundedPrevious,
        })}
        tabIndex={0}
      >
        {hasChange && roundedCurrent > roundedPrevious && (
          <MLIcon type="trend_up" className={styles.trendUpIcon} />
        )}
        {hasChange && roundedCurrent < roundedPrevious && (
          <MLIcon type="trend_down" className={styles.trendDownIcon} />
        )}
        {formatChange(student.currentGrade, student.previousGrade)}
      </td>
    </tr>
  );
};

export default StudentCourseTotalRow;
